import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, dateFnsLocalizer, Views } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay, addDays, startOfMonth, endOfMonth, differenceInWeeks } from 'date-fns';
import zhTW from 'date-fns/locale/zh-TW';
import { Container, ButtonGroup, ToggleButton, Button, Modal, Form } from 'react-bootstrap';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import api from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import '../coach/Schedule.css';
import './Booking.css';
import { sl } from 'date-fns/locale';
import { all } from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { 
  faCloudSun,         // 陽光雲
  faCoffee,           // 咖啡
  faUmbrella,         // 陽傘
  faClock,            // 時鐘
  faCloudMoon,        // 月亮雲
  faMugHot,           // 熱飲
  faSunPlantWilt,     // 夕陽
  faCloudSunRain,     // 陽光雨
  faPersonSkiing,     // 雙板滑雪
  faPersonSnowboarding // 單板滑雪
} from '@fortawesome/free-solid-svg-icons';
// 設置本地化
const locales = {
  'zh-TW': zhTW,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek: (date) => startOfWeek(date, { locale: zhTW }),
  getDay,
  locales,
});

const timeSlots = {
  'MORNING': '上午 (09:00-12:00)',
  'AFTERNOON': '下午 (13:00-16:00)',
};

const timeSlotIcons = {
  MORNING: faCloudSun,
  AFTERNOON: faCoffee
};

const statusColors = {
  OPEN: '#28a745',     // 可預約
  BOOKED: '#dc3545',   // 已預約
  TRANSPARENT: '#e9ecef', // 透明
};

// Toast 配置
const toastConfig = {
  position: "top-right",
  autoClose: 3000,        // 3秒後自動關閉
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored"        // 添加主題設定
};

function WeekView({ currentDate, events, onEventClick, onSlotSelect, selectedSchedules }) {
  const startDate = startOfWeek(currentDate, { locale: zhTW });
  const days = Array.from({ length: 7 }, (_, i) => addDays(startDate, i));
  const slots = ['上午', '下午'];

  return (
    <div className="week-view">
      <div className="time-header">
        <div className="day-label"></div>
        {slots.map((slot) => (
          <div key={slot} className="time-label">{slot}</div>
        ))}
      </div>

      {days.map((day, dayIndex) => (
        <div key={dayIndex} className="day-row">
          <div className="day-label">
            <div className="day-name">{format(day, 'eee', { locale: zhTW })}</div>
            <div className="day-date">{format(day, 'MM/dd')}</div>
          </div>
          
          {slots.map((slot, slotIndex) => {
            const timeSlot = slotIndex === 0 ? 'MORNING' : 'AFTERNOON';
            const dayEvents = events.filter(event => 
              format(new Date(event.start), 'yyyy-MM-dd') === format(day, 'yyyy-MM-dd') &&
              event.timeSlot === timeSlot
            );

            return (
              <div
                key={slot}
                className="time-slot"
                onClick={() => onSlotSelect({
                  date: day,
                  timeSlot
                })}
              >
                {dayEvents.map((event, eventIndex) => (
                  <div
                    key={eventIndex}
                    className={`event ${
                      selectedSchedules.some(s => s.id === event.id) ? 'selected' : ''
                    }`}
                    style={{ 
                      backgroundColor: statusColors[event.status],
                      //border: selectedSchedules.some(s => s.id === event.id) 
                      //  ? '2px solid #000' 
                      //  : 'none',
                      //boxShadow: selectedSchedules.some(s => s.id === event.id)
                      //  ? '0 0 0 2px #fff'
                      //  : 'none'
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onEventClick(event);
                    }}
                  >
                    {event.location}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

const generateEvents = (originalEvents) => {
  const Events = [...originalEvents];
  const allEvents = [];
  
  // 按日期分組事件
  const eventsByDate = originalEvents.reduce((acc, event) => {
    const dateKey = format(event.start, 'yyyy-MM-dd');
    if (!acc[dateKey]) {
      acc[dateKey] = [];
    }
    acc[dateKey].push(event);
    return acc;
  }, {});

  // 為只有一個時段的日期生成透明事件
  Object.entries(eventsByDate).forEach(([dateStr, dateEvents]) => {
    if (dateEvents.length === 1) {
      const timeSlots = [
        'MORNING',
        'AFTERNOON'
      ];

      const existingSlot = dateEvents[0].timeSlot;
      console.log('existingSlot:', existingSlot);

      timeSlots.forEach(slot => {
        // 跳過已存在的時段
        if (slot !== existingSlot) {
          const transparentEvent = {
            id: `transparent-${dateStr}-${slot}`,
            title: '未開放',//`${slot==='MORNING' ? '上午' : '下午'}`,
            start: dateEvents[0].start,
            end: dateEvents[0].end,
            status: 'TRANSPARENT',
            timeSlot: slot,
            location: '未開放',
            allDay: true
          };
          if(slot === 'MORNING') {
            allEvents.push(transparentEvent);
            allEvents.push(dateEvents[0]);
          }
          else {
            allEvents.push(dateEvents[0]);
            allEvents.push(transparentEvent);
          }
        }
      });
    }
    else {
      allEvents.push(...dateEvents);
    }
  });
  return allEvents;
};

function Booking() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [viewType, setViewType] = useState(window.innerWidth < 400 ? 'week' : 'month');
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [coaches, setCoaches] = useState([]);
  const [selectedCoach, setSelectedCoach] = useState(() => {
    // 從 localStorage 獲取上次選擇的教練
    const savedCoach = localStorage.getItem('selectedCoach');
    console.log('Initial selectedCoach from localStorage:', savedCoach);
    return savedCoach || '';
  });
  const [selectedSchedules, setSelectedSchedules] = useState([]);
  const [showBulkBookingModal, setShowBulkBookingModal] = useState(false);
  const [preferredLocation, setPreferredLocation] = useState('');
  const [numberofStudents, setNumberofStudents] = useState(1);
  const [note, setNote] = useState('');
  const { scheduleData } = useAuth();
  const [courseType, setCourseType] = useState('SNOWBOARD');

  useEffect(() => {
    const coachHashedId = scheduleData.coachHashedId;
    const month = scheduleData.month;
    console.log('coachHashedId = ', coachHashedId);
    console.log('month = ', month);
  }, [scheduleData]);

  // 當選擇的教練改變時，保存到 localStorage
  useEffect(() => {
    console.log('選擇的教練改變，保存到 localStorage:', selectedCoach);
    if (selectedCoach) {
      localStorage.setItem('selectedCoach', selectedCoach);
    } else {
      localStorage.removeItem('selectedCoach');
    }
  }, [selectedCoach]);

  // 獲取教練列表
  useEffect(() => {
    const fetchCoaches = async () => {
      try {
        const response = await api.get('/coaches/');
        setCoaches(response.data);
        
        // 如果有保存的教練ID但不在當前教練列表中，清除保存的值
        const savedCoach = localStorage.getItem('selectedCoach');
        if (savedCoach && !response.data.some(coach => coach.id.toString() === savedCoach)) {
          localStorage.removeItem('selectedCoach');
          setSelectedCoach('');
        }
      } catch (err) {
        setError('無法獲取教練列表');
      }
    };
    fetchCoaches();
  }, []);

  // 將 fetchSchedules 使用 useCallback 包裝
  const fetchSchedules = useCallback(async () => {
    try {
      //console.log('開始獲取行程...');
      //console.log('當前選擇的教練ID:', selectedCoach);
      
      if (!selectedCoach) {
        //console.log('未選擇教練，跳過獲取行程');
        return;
      }
      
      const url = `/schedules/?coach=${selectedCoach}`;

      const response = await api.get(url);

      // 根據日期和時段排序行程
      response.data.sort((a, b) => {
        // 先比較日期
        const dateComparison = new Date(a.date) - new Date(b.date);
        if (dateComparison !== 0) {
          return dateComparison;
        }
        
        // 日期相同時,比較時段 (MORNING 排在 AFTERNOON 前面)
        if (a.time_slot === 'MORNING' && b.time_slot === 'AFTERNOON') {
          return -1;
        }
        if (a.time_slot === 'AFTERNOON' && b.time_slot === 'MORNING') {
          return 1;
        }
        return 0;
      });
      
      const formattedEvents = response.data.map(schedule => {
        const event = {
          id: schedule.id,
          title: `${schedule.time_slot==='MORNING' ? '上午' : '下午'}\n${schedule.location}`,
          start: new Date(schedule.date),
          end: new Date(schedule.date),
          status: schedule.status,
          timeSlot: schedule.time_slot,
          location: schedule.location,
          allDay: true
        };
        return event;
      });
      
      // 當原始事件加載後
      const enhancedEvents = generateEvents(formattedEvents);
      //console.log('enhancedEvents:', enhancedEvents);
      setEvents(enhancedEvents);
    } catch (err) {
      //console.error('獲取行程失敗:', err);
      //console.error('錯誤詳情:', err.response?.data || err.message);
      setError('無法獲取行程');
    }
  }, [selectedCoach]); // 添加 selectedCoach 作為依賴

  // 修改 useEffect，添加 fetchSchedules 作為依賴
  useEffect(() => {
    if (selectedCoach) {
      fetchSchedules();
    }
  }, [selectedCoach, fetchSchedules]); // 添加 fetchSchedules 作為依賴

  // 處理時段選擇
  const handleSlotSelectWeek = (selection) => {
    // 不處理
    /*
    const availableSchedule = events.find(event => 
      format(event.start, 'yyyy-MM-dd') === format(selection.date, 'yyyy-MM-dd') &&
      event.timeSlot === selection.timeSlot &&
      event.status === 'OPEN'
    );

    if (availableSchedule) {
      setError('');
      setSelectedSchedule(availableSchedule);
      setShowModal(true);
    }
    */
  };

  // 提交預約
  const handleBooking = async () => {
    try {
      setLoading(true);
      setError('');
      
      // 使用正確的批量預約 API
      await api.post('/bookings/bulk_create/', {
        schedules: selectedSchedules.map(schedule => schedule.id),
        preferred_location: preferredLocation,
        type: courseType,
        numberof_students: numberofStudents,
        note: note
      });

      await fetchSchedules();
      setShowBulkBookingModal(false);
      setSelectedSchedules([]);
      setPreferredLocation('');
      setNumberofStudents(1);
      setNote('');  
      
      showSuccessToast(); 
    } catch (err) {
      // 將錯誤轉換為陣列格式
      //console.log('錯誤詳情:', err);
      if (err.response?.data && typeof err.response?.data === 'object') {
        const errorMessages = Object.values(err.response.data).flat();
        setError(errorMessages.join('\n'));
        /*
        toast.error('❌ ' + errorMessages.join('\n'), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: '#f44336',
            color: 'white',
            fontSize: '16px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
          }
        });
        */
      }
      else {
        setError('預約失敗');
      }
    } finally {
      setLoading(false);
    }
  };

  // 處理視圖切換
  const handleViewChange = (newView) => {
    setViewType(newView);
  };

  // 月曆視圖的事件樣式
  const eventStyleGetter = (event) => {
    if (event.status === 'TRANSPARENT') {
      return {
        style: {
          backgroundColor: statusColors[event.status],
          opacity: 0.8,
          cursor: 'default'
        }
      };
    }
    return {
      style: {
        backgroundColor: statusColors[event.status],
        borderRadius: '3px',
        opacity: 0.8,
        color: 'white',
        border: 'none',
        display: 'block',
        padding: '0px 0px'
      }
    };
  };

  // 月曆選擇時段
  const handleSlotSelect = ({ start, end, slots }) => {
    // 不處理
  };

  // 處理事件點擊
  const handleEventClick = (event) => {
    if (event.status !== 'OPEN') {
      alert('此時段已被預約');
      return;
    }

    setSelectedSchedules(prev => {
      const isSelected = prev.some(schedule => schedule.id === event.id);
      //console.log('isSelected:', isSelected);
      if (isSelected) {
        return prev.filter(schedule => schedule.id !== event.id);
      } else {
        const newSchedules = [...prev, event].sort((a, b) => {
          // 按日期和時段排序
          const dateCompare = new Date(a.start) - new Date(b.start);
          if (dateCompare !== 0) return dateCompare;
          return a.timeSlot === 'MORNING' ? -1 : 1;
        });
        //console.log('newSchedules:', newSchedules);
        return newSchedules;
      }
    });
  };

  useEffect(() => {
    // 計算日曆需要顯示的確切週數
    const firstDayOfMonth = startOfMonth(currentDate);
    const firstDayWeekday = getDay(firstDayOfMonth);
    const daysBeforeMonth = firstDayWeekday === 0 ? 6 : firstDayWeekday - 1; // 調整為週一開始
    const firstCalendarDate = addDays(firstDayOfMonth, -daysBeforeMonth);
    
    const lastDayOfMonth = endOfMonth(currentDate);
    const lastDayWeekday = getDay(lastDayOfMonth);
    const daysAfterMonth = lastDayWeekday === 0 ? 0 : 7 - lastDayWeekday;
    const lastCalendarDate = addDays(lastDayOfMonth, daysAfterMonth);

    const weeksInMonth = Math.ceil(differenceInWeeks(lastCalendarDate, firstCalendarDate, { roundingMethod: 'ceil' }));
    
    const container = document.querySelector('.calendar-container');
    if (container) {
      container.dataset.weeks = weeksInMonth;  // 設置 data-weeks 屬性
      container.style.setProperty('--number-of-weeks', weeksInMonth);
    }
  }, [currentDate]);

  // 修改成功的 Toast
  const showSuccessToast = () => {
    toast.success('🎉 預約成功！', {
      ...toastConfig,
      style: {
        background: '#4CAF50',
        color: 'white',
        fontSize: '16px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }
    });
  };

  // 修改錯誤的 Toast
  const showErrorToast = (message) => {
    toast.error('❌ ' + message, {
      ...toastConfig,
      style: {
        background: '#f44336',
        color: 'white',
        fontSize: '16px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }
    });
  };

  return (
    <Container className="py-2">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        limit={3}           // 限制同時顯示的 toast 數量
      />

      {/*
      <h2 className="mb-4">課程預約</h2>
      */}

      <Form.Group className="mb-4">
        <Form.Label>選擇教練</Form.Label>
        <Form.Select
          value={selectedCoach}
          onChange={(e) => {
            const coachId = e.target.value;
            console.log('選擇教練變更:', coachId);
            setSelectedCoach(coachId);
          }}
        >
          <option value="">請選擇教練</option>
          {coaches.map(coach => (
            <option 
              key={coach.id} 
              value={coach.id}
            >
              {coach.username}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {selectedCoach && (
        <div className="schedule-container">
          <div className="schedule-header">
            <div className="navigation-controls d-flex align-items-center justify-content-between">
              {/* 上一週/月按鈕 */}
              <Button 
                variant="outline-secondary" 
                size="sm"
                className="navigation-button" 
                onClick={() => setCurrentDate(prev => 
                  viewType === 'week' 
                    ? addDays(prev, -7) 
                    : new Date(prev.getFullYear(), prev.getMonth() - 1, 1)
                )}
              >
                &lt; {viewType === 'week' ? '上週' : '上月'}
              </Button>

              {/* 中間的日期和視圖切換 */}
              <div className="d-flex flex-column align-items-center mx-4">
                <span className="current-week fw-bold mb-2">
                  {format(currentDate, 'yyyy年MM月')}
                </span>
                <ButtonGroup>
                  {[
                    { name: '週曆', value: 'week' },
                    { name: '月曆', value: 'month' }
                  ].map((type) => (
                    <ToggleButton
                      key={type.value}
                      id={`view-type-${type.value}`}
                      type="radio"
                      variant="outline-primary"
                      name="view-type"
                      value={type.value}
                      checked={viewType === type.value}
                      onChange={(e) => handleViewChange(e.currentTarget.value)}
                      size="sm"
                      className="px-3"
                    >
                      {type.name}
                    </ToggleButton>
                  ))}
                </ButtonGroup>
              </div>

              {/* 下一週/月按鈕 */}
              <Button 
                variant="outline-secondary" 
                size="sm"
                className="navigation-button"
                onClick={() => setCurrentDate(prev => 
                  viewType === 'week'
                    ? addDays(prev, 7)
                    : new Date(prev.getFullYear(), prev.getMonth() + 1, 1)
                )}
              >
                {viewType === 'week' ? '下週' : '下月'} &gt;
              </Button>
            </div>
          </div>
{/*
          <div className="schedule-legend">
            {Object.entries({
              OPEN: '可預約',
            }).map(([key, label]) => (
              <div key={key} className="legend-item">
                <span 
                  className="legend-color" 
                  style={{ backgroundColor: statusColors[key] }}
                ></span>
                <span>{label}</span>
              </div>
            ))}
          </div>
          */}
          {viewType === 'week' ? (
            <WeekView
              currentDate={currentDate}
              events={events}
              onEventClick={handleEventClick}
              onSlotSelect={handleSlotSelectWeek}
              selectedSchedules={selectedSchedules}
            />
          ) : (
            <div className="calendar-container">
              <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                selectable
                onSelectSlot={handleSlotSelect}
                onSelectEvent={handleEventClick}
                eventPropGetter={eventStyleGetter}
                defaultView={Views.MONTH}
                views={[Views.MONTH]}
                toolbar={false}
                date={currentDate}
                onNavigate={(date) => setCurrentDate(date)}
                messages={{
                  showMore: total => `還有 ${total} 個...`
                }}
                formats={{
                  monthHeaderFormat: date => format(date, 'yyyy年MM月'),
                  dayHeaderFormat: date => format(date, 'MM/dd'),
                  dayRangeHeaderFormat: ({ start, end }) => 
                    `${format(start, 'yyyy年MM月dd日')} - ${format(end, 'MM月dd日')}`,
                  dayFormat: date => format(date, 'd')
                }}
                components={{
                  event: ({ event }) => (
                    <div
                      className={`event ${selectedSchedules.some(e => e.id === event.id) ? 'selected' : ''}`}
                      style={{
                        backgroundColor: statusColors[event.status],
                        color: 'white',
                        padding: '0px 0px',
                        borderRadius: '3px',
                        cursor: event.status === 'BOOKED' ? 'not-allowed' : event.status === 'TRANSPARENT' ? 'default' : 'pointer',
                        //border: selectedSchedules.some(e => e.id === event.id) ? '2px solid #000' : 'none',
                        //boxShadow: selectedSchedules.some(e => e.id === event.id) ? '0 0 0 2px #fff' : 'none',
                        ':hover': event.status === 'TRANSPARENT' ? {} : {
                          transform: 'translateY(-1px)',
                          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                          opacity: 0.9
                        }
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (event.status === 'OPEN') {
                          handleEventClick(event);
                        }
                      }}
                    >
                      <div style={{ fontSize: '0.7em' }}>
                        {event.timeSlot === 'MORNING' ? '上午' : '下午'}
                      </div>
                      <div>
                        {event.location}
                      </div>
                    </div>
                  ),
                  header: ({ date }) => {
                    const weekdays = ['週日', '週一', '週二', '週三', '週四', '週五', '週六'];
                    return <span>{weekdays[date.getDay()]}</span>;
                  }
                }}
              />
            </div>
          )}
        </div>
      )}

      {/* 添加批量更新按鈕 */}
      {selectedSchedules.length > 0 && (
        <Button
          variant="primary"
          className="mb-3 bulk-booking-button"
          onClick={() => {
            setError('');
            setShowBulkBookingModal(true);
          }}
        >
          批量預約 ({selectedSchedules.length} 個行程)
        </Button>
      )}

      <Modal 
        show={showBulkBookingModal} 
        onHide={() => {
          setShowBulkBookingModal(false);
          setSelectedSchedules([]);
          setPreferredLocation('');
          setNumberofStudents(1);
          setNote('');
        }}
        backdrop="static"  // 添加這個屬性
        keyboard={false}   // 添加這個屬性
      >
        <Modal.Header closeButton>
          <Modal.Title>確認預約</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && (
            <div className="alert alert-danger" style={{ whiteSpace: 'pre-line' }}>
              {error}
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label>期望上課地點</Form.Label>
            <Form.Control
              type="text"
              value={preferredLocation}
              onChange={(e) => setPreferredLocation(e.target.value)}
              placeholder="請輸入期望的上課地點"
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>課程類型</Form.Label>
            <Form.Select
              value={courseType}
              onChange={(e) => setCourseType(e.target.value)}
            >
              <option value="SKI">
                <FontAwesomeIcon icon={faPersonSkiing} className="me-2" />
                雙板(SKI)
              </option>
              <option value="SNOWBOARD">
                <FontAwesomeIcon icon={faPersonSnowboarding} className="me-2" />
                單板(SNOWBOARD)
              </option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>學生人數</Form.Label>
            <div className="d-flex align-items-center">
              <Button
                variant="outline-secondary"
                onClick={() => setNumberofStudents(prev => Math.max(1, prev - 1))}
                className="me-2"
              >
                -
              </Button>
              <Form.Control
                type="number"
                value={numberofStudents}
                onChange={(e) => {
                  const value = e.target.value === '' ? '' : parseInt(e.target.value);
                  if (value === '' || (!isNaN(value) && value >= 1)) {
                    setNumberofStudents(value);
                  }
                }}
                onBlur={() => {
                  // 當失去焦點時，如果是空值或小於1，則設為1
                  if (numberofStudents === '' || numberofStudents < 1) {
                    setNumberofStudents(1);
                  }
                }}
                style={{ 
                  width: '80px',
                  textAlign: 'center',
                  WebkitAppearance: 'none',
                  MozAppearance: 'textfield'
                }}
                min="1"
                required
              />
              <Button
                variant="outline-secondary"
                onClick={() => setNumberofStudents(prev => prev + 1)}
                className="ms-2"
              >
                +
              </Button>
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>備註</Form.Label>
            <Form.Control
              as="textarea"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="請輸入備註"
            />
          </Form.Group>

          {selectedSchedules.length > 0 && (
            <div>
              <h6>選擇的時段：</h6>
              <ul>
                {selectedSchedules.map(schedule => (
                  <li key={schedule.id}>
                    {format(schedule.start, 'yyyy年MM月dd日')} - 
                    {schedule.timeSlot === 'MORNING' ? '上午' : '下午'}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="secondary" 
            onClick={() => {
              setShowBulkBookingModal(false);
              setSelectedSchedules([]);
              setPreferredLocation('');
              setNumberofStudents(1);
              setNote('');
            }}
          >
            取消
          </Button>
          <Button 
            variant="primary" 
            onClick={handleBooking}
            disabled={loading || selectedSchedules.length === 0 || !preferredLocation}
          >
            {loading ? '處理中...' : '確認預約'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default Booking;